import React from 'react';
import { DrawerHeader, ModalProps } from '@features/Modal';
import { ISettingsTransactionsDto } from '@shared/api';
import { AffectedPositions } from './components';
import './TransactionViewDrawer.scss';
import { Steps } from '@features/Steps';
import { GeneralTransactions } from './components/GeneralTransactions';

interface ITransactionViewModalProps extends ModalProps {
    transaction: ISettingsTransactionsDto;
}

export const TransactionViewDrawer: React.FC<ITransactionViewModalProps> = (props) => {
    const { transaction } = props;
    const typesWithAffectedPositions = [2, 9];
    const steps = [{ title: 'General', step: <GeneralTransactions transaction={transaction} /> }];

    if (typesWithAffectedPositions.includes(transaction.type)) {
        steps.push({ title: 'Affected Positions', step: <AffectedPositions transactionId={transaction.id} /> });
    }

    return (
        <div className='widget-transaction-view-drawer'>
            <DrawerHeader headerTitle={`Transaction ID: ${transaction.id}`} />
            <Steps
                footerClassName='widget-transaction-view-drawer__footer'
                headerClassName='widget-transaction-view-drawer__header'
                className='widget-transaction-view-drawer__steps'
                headerStepLabelClassName='widget-transaction-view-drawer__header-step-label'
                headerStepLineClassName='widget-transaction-view-drawer__header-step-line'
                titles={steps.map((item) => item.title)}
                footerVisible={false}
            >
                {steps.map((item) => item.step)}
            </Steps>
        </div>
    );
};
